// Dynamic API configuration for frontend
const getApiBaseUrl = () => {
  // In browser
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Local development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:4002';
    }
    // Production / other environments
    return '/nbe';
  }

  // Node/SSR fallback
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4002';
  }
  return '/nbe';
};

export const API_BASE_URL = getApiBaseUrl();

// Short link base URL for constructing user-facing short links
const getShortLinkBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:4002';
    }
    // Production hardcoded domain for short links
    return 'https://dynalink.rovidant.com/nbe';
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4002';
  }
  return 'https://dynalink.rovidant.com/nbe';
};

export const SHORT_LINK_BASE_URL = getShortLinkBaseUrl();
